import { CpanelLicensePlanGroup } from './cpanel-license-plan-group';
import { CpanelLicensePlanParent } from './cpanel-license-plan-parent';
import { CpanelLicensePlanType } from './cpanel-license-plan-type';

export class CpanelLicensePlan {
	public id: number;
	public name: string;
	public description: string;
	public monthlyFee: number;
	public upfrontFee: number;
	public years: number;
	public licensePlanTypeId: number;
	public licensePlanGroupId: number;
	public sortOrder: number;

	public hasChildren: boolean;
	public parents: CpanelLicensePlanParent[];
	public licensePlanType: CpanelLicensePlanType;
	public licensePlanGroup: CpanelLicensePlanGroup;

	constructor(cpanelLicensePlan?: CpanelLicensePlan) {
		Object.assign(this, cpanelLicensePlan);
	}
}
